<template lang="pug">
    div
        CarDetails(:carList="sortedCars" ":selectedIndex"="bubble.userPref" @change="updateSelected" v-on="$listeners" :trips="trips" :bubble="bubble" :currentCar="currentCar")
</template>

<script>
import CarDetails from "./CarDetails.vue";
import HowThisWorks from "./HowThisWorks";
export default {
  props: ["sortedCars", "bubble", "trips", "currentCar"],
  components: {
    CarDetails,
    HowThisWorks,
  },
  computed: {
    validCarCount() {
      return this.sortedCars.length;
    },
  },
  methods: {
    updateSelected(car) {
      this.bubble.userPref = this.sortedCars.indexOf(car);
      const parsed = JSON.stringify(this.sortedCars[this.bubble.userPref]);
      localStorage.setItem("car", parsed);
    },
  },
};
</script>
